import { Navigate } from 'react-router-dom';

export const PrivateRoute = ({ component, isAuth }) => {
  if (isAuth) {
    return component;
  }
  return <Navigate to={'/login'} replace />;
};
